module.exports = __webpack_public_path__ + "static/media/ScreenTimeScreen.325c4b8c.png";